import { Link, useLocation } from "react-router-dom";
import { isGoogleOAuthConfigured } from "../auth-config";
import { useAuth } from "../auth/AuthContext";
import { resolvePostLoginRoute } from "../auth/post-login-route";
import { PUBLIC_HOME_PATH } from "../routes/public-home-path";

const SECTION_LINKS = [
  { label: "How it works", hash: "#how-it-works" },
  { label: "Features", hash: "#features" },
  { label: "Pricing", hash: "#pricing" },
] as const;

function isHomePath(pathname: string): boolean {
  return pathname === "/" || pathname === PUBLIC_HOME_PATH;
}

export default function LandingNav() {
  const { status, profile, signOut } = useAuth();
  const location = useLocation();
  const oauthReady = isGoogleOAuthConfigured();
  const authed = status !== "anonymous";
  const onHome = isHomePath(location.pathname);

  const appHref =
    profile?.role === "teacher"
      ? "/teacher"
      : profile
        ? resolvePostLoginRoute(profile)
        : "/onboarding";

  return (
    <header className="landing-nav">
      <Link to={PUBLIC_HOME_PATH} className="landing-brand" aria-label="Code Create Slay home">
        <img className="landing-brand-logo" src="/logo.png" alt="" width={44} height={44} />
        <span className="landing-brand-name">Code Create Slay</span>
      </Link>
      <nav className="landing-nav-links" aria-label="Site">
        {SECTION_LINKS.map((link) =>
          onHome ? (
            <a key={link.hash} href={link.hash} className="landing-nav-link">
              {link.label}
            </a>
          ) : (
            <Link
              key={link.hash}
              to={`${PUBLIC_HOME_PATH}${link.hash}`}
              className="landing-nav-link"
            >
              {link.label}
            </Link>
          ),
        )}
        {location.pathname === "/about" ? (
          <span className="landing-nav-link landing-nav-link--active" aria-current="page">
            About
          </span>
        ) : (
          <Link to="/about" className="landing-nav-link">
            About
          </Link>
        )}
      </nav>
      <div className="landing-nav-actions" data-google-oauth={oauthReady ? "configured" : "pending"}>
        {authed ? (
          <>
            <Link className="btn primary" to={appHref}>
              {profile?.role === "teacher" ? "Teacher workspace" : "Go to app"}
            </Link>
            <button type="button" className="btn secondary" onClick={() => signOut()}>
              Sign out
            </button>
          </>
        ) : (
          <Link className="btn primary landing-login" to="/login">
            Log in
          </Link>
        )}
      </div>
    </header>
  );
}
